export type Page = 'map' | 'mannequin';

/** The page a location hash names: `#/mannequin` (with or without a query) is the Mannequin page, anything else the map. */
export function parseRoute(hash: string): Page {
  const path = hash.replace(/^#/, '').split('?')[0];
  return path === '/mannequin' ? 'mannequin' : 'map';
}
